<script setup lang="ts">
import { onMounted } from 'vue';
import { useGameStore } from './stores/game';
import DeviceSetup from './components/DeviceSetup.vue';
import GameScreen from './components/GameScreen.vue';
import AdminScreen from './components/AdminScreen.vue';

const store = useGameStore();

onMounted(() => {
  store.init();
});
</script>

<template>
  <DeviceSetup v-if="store.screen === 'setup'" />
  <GameScreen v-else-if="store.screen === 'game'" />
  <AdminScreen v-else-if="store.screen === 'admin'" />
</template>
